import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DialogData, TabGatewaysComponent } from '../tabs/tab-gateways/tab-gateways.component';
import { RegisteredGateway} from '../services/api-gateway.service';

@Component({
    selector: 'gateway-dialog',
    templateUrl: './gateway-dialog.component.html',
    styleUrls: ['./gateway-dialog.component.scss'],
    standalone: false
})
export class GatewayDialogComponent {
  dialogType : 'update' | 'register';
  dialogDevice : RegisteredGateway;
  gatewayForm = new FormGroup({
    mode: new FormControl<string|undefined>(undefined,[Validators.required,Validators.pattern('(idle|continuous)')]),
    power: new FormControl<string|undefined>(undefined,[Validators.required,Validators.pattern('(low|high)')]),
    gateway_id: new FormControl<string|null>(null,[Validators.required,Validators.minLength(16),Validators.required,Validators.maxLength(16),Validators.pattern('[a-fA-F0-9]+')]),
    country_code: new FormControl<string|null>(null,[Validators.required]),
  });

  constructor(
    public dialogRef: MatDialogRef<TabGatewaysComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: DialogData,
  ) {
    this.dialogType = dialogData.dialogType;
    this.dialogDevice = dialogData.deviceData;
    if (this.dialogType == 'update'){
      this.gatewayForm.controls.mode.setValue(dialogData.deviceData.mode)
      this.gatewayForm.controls.power.setValue(dialogData.deviceData.power)
      this.gatewayForm.controls.gateway_id.setValue(dialogData.deviceData.gateway_id)
      this.gatewayForm.controls.country_code.setValue(dialogData.deviceData.country_code)
    }
  }

  fakeNgModel(){
    // return form values to dialog data
    this.dialogDevice.mode = <string>this.gatewayForm.controls.mode.value;
    this.dialogDevice.power = <string>this.gatewayForm.controls.power.value;
    this.dialogDevice.gateway_id = <string>this.gatewayForm.controls.gateway_id.value;
    this.dialogDevice.country_code = <string>this.gatewayForm.controls.country_code.value;
  }

  confirmDevice(){
    this.fakeNgModel();
    this.dialogRef.close(true);
  }

  cancelDevice(){
    this.dialogRef.close(false);
  }
}
